import _typeof from "@babel/runtime/helpers/esm/typeof";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import { isProductInStock, isProductDiscontinued } from '~/utils/ProductAvailability';

/**
 * Returns the different filtered variants
 *
 * @param      {Object}  product  The product
 * @return     {Object}  {
 *                        variants: Unfiltered variants,
 *                        masterVariant,
 *                        inStockVariants: Filtered and ordered by price variants,
 *                        displayVariant: Variant to display if the master variant is unavailable
 *                       }
 */
export function useProductVariants(product) {
  var productRef = ref(product);
  var variants = computed(function () {
    var _productRef$value;
    // A product with variants
    if ((_productRef$value = productRef.value) !== null && _productRef$value !== void 0 && _productRef$value.variants) {
      var _productRef$value2;
      return (_productRef$value2 = productRef.value) === null || _productRef$value2 === void 0 ? void 0 : _productRef$value2.variants;
    }

    // A product without variants
    if (_typeof(productRef.value) === 'object' && !Array.isArray(productRef.value) && productRef.value !== null) {
      return [productRef.value];
    }

    // An array of variants
    if (Array.isArray(productRef.value)) {
      return productRef.value;
    }
  });
  var masterVariant = computed(function () {
    var _productRef$value3, _filteredVariant$;
    if (((_productRef$value3 = productRef.value) === null || _productRef$value3 === void 0 ? void 0 : _productRef$value3._master) === true) return productRef.value;
    var filteredVariant = variants.value.filter(function (variant) {
      return (variant === null || variant === void 0 ? void 0 : variant._master) === true;
    });
    return (_filteredVariant$ = filteredVariant[0]) !== null && _filteredVariant$ !== void 0 ? _filteredVariant$ : null;
  });
  var inStockVariants = computed(function () {
    var _variants$value$filte;
    var filteredVariants = (_variants$value$filte = variants.value.filter(function (variant) {
      return isProductInStock(variant);
    })) !== null && _variants$value$filte !== void 0 ? _variants$value$filte : [];
    var orderedVariants = filteredVariants.sort(function (a, b) {
      var _a$price, _a$price$value, _b$price, _b$price$value;
      return (a === null || a === void 0 ? void 0 : (_a$price = a.price) === null || _a$price === void 0 ? void 0 : (_a$price$value = _a$price.value) === null || _a$price$value === void 0 ? void 0 : _a$price$value.centAmount) - (b === null || b === void 0 ? void 0 : (_b$price = b.price) === null || _b$price === void 0 ? void 0 : (_b$price$value = _b$price.value) === null || _b$price$value === void 0 ? void 0 : _b$price$value.centAmount);
    });
    return orderedVariants;
  });
  var displayVariant = computed(function () {
    if (!inStockVariants.value.length || masterVariant.value && isProductInStock(masterVariant.value) && !isProductDiscontinued(masterVariant.value)) {
      return masterVariant.value;
    } else {
      return inStockVariants.value[0];
    }
  });
  return {
    variants: variants,
    masterVariant: masterVariant,
    inStockVariants: inStockVariants,
    displayVariant: displayVariant
  };
}